import { toSvg } from "html-to-image";

/**
 * Downloads a file with the given URI and filename
 * @param {string} uri - The data URI or URL of the file
 * @param {string} filename - The name for the downloaded file
 */
export function downloadFile(uri, filename) {
  const link = document.createElement("a");
  link.href = uri;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/**
 * Exports the canvas as an SVG file
 * @param {Object} params - Parameters for SVG export
 * @param {React.RefObject} params.stageRef - Reference to the Konva stage
 * @param {React.RefObject} params.transformerRef - Reference to the Konva transformer
 */
export function handleSvgExport({ stageRef, transformerRef }) {
  const stage = stageRef.current;
  if (!stage) return;

  // Hide transformer during export for a clean output
  const node = stage.container();

  // Hide transformer during export for a clean output
  const transformer = transformerRef.current;
  const transformerExists =
    transformer && typeof transformer.nodes === "function";
  const currentNodes = transformerExists ? transformer.nodes() : [];

  if (transformerExists) {
    transformer.nodes([]);
    transformer.getLayer()?.batchDraw();
    transformer.getLayer()?.batchDraw();
  }

  // Use html-to-image to generate an SVG data URL
  toSvg(node, { cacheBust: true })
    .then((dataUrl) => {
      downloadFile(dataUrl, "kvk.svg");
    })
    .catch((err) => {})
    .finally(() => {
      // Restore transformer nodes
      if (transformerExists) {
        transformer.nodes(currentNodes);
        transformer.getLayer()?.batchDraw();
      }
    });
}

/**
 * Exports the canvas as a PDF file
 * @param {React.RefObject} stageRef - Reference to the Konva stage
 */
export function handleExportPDF(stageRef) {
  const stage = stageRef.current;
  if (!stage) return;

  // Get all Konva layers and nodes
  const svgContent = stage.toDataURL({ mimeType: "image/svg+xml" });

  // Create a download link
  const link = document.createElement("a");
  link.download = "drawing.svg";
  link.href = svgContent;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
